<template>
  <div class="BreadCrumb">
    <ul class="clear">
        <li class="left" @click="goHome"><a href="javascript:;">Home</a></li>
        <li class="left" v-for="(item,index) in crumbList" :key="index" @click="goRouter(item)"><a href="javascript:;">{{item.name}}</a></li>
    </ul>
  </div>
</template>

<script>
export default {
  components: {
    
  },
  name: 'BreadCrumb',
  data () {
    return {
        
    }
  },
  props: {
      crumbList:{
          type:Array
      }
  },
  watch: {

  },
  methods: {
        goHome(){
            this.$router.push('/home')
        },
        goRouter(item){
            if(item.url){
                this.$router.push(item.url)
            }
        }
  },
  filters: {

  },
  computed: {

  },
  created () {
    
  },
  mounted () {
    // console.log(this.$route)
    // console.log(this.$route.params.path)
    // console.log(this.$route.router)
    // console.log(this.$route.matched)
    // console.log(this.$route.name)
    // $route.path 当前路由对象的路径，如'/vi
    // $route.query 请求参数，如/foo?user=1获取到query.user = 1
    // $route.router 所属路由器以及所属组件信息
    // $route.matched 数组，包含当前匹配的路径中所包含的所有片段所对应的配置参数对象。
    // $route.name 当前路径名字
  },
  destroyed () {
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
    .BreadCrumb{
        ul{
            padding-top: 32px;
            padding-bottom: 64px;
            li{
                a{
                    color: #808080;
                    &:hover{
                        color: #D8000F;
                    }
                }
                &:hover{
                    color: #D8000F;
                }
                cursor: pointer;
                font-size:14px;
                color:rgba(128,128,128,1);
                line-height:16px;
                margin-right: 16px;
                &::after{
                    content: '';
                    float: right;
                    margin-left: 8px;
                    // display: inline-block;
                    width: 16px;
                    height: 16px;
                    background: url(../../assets/common/icon_com_sj_moregrey.png) no-repeat center;
                }
                &:last-child{
                    &::after{
                        display: none;
                    }
                }
            }
        }
    }
</style>
